module.exports = __webpack_public_path__ + "static/img/4.dfcc973.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/4.png
// module id = GJ4F
// module chunks = 0